import {
    GET_BARCODE_RECEIVE_SETS_SUCCESS,
    GET_BARCODE_RECEIVE_SETS_FAILURE,
    GET_PRODUCT_DETAILS_SUCCESS,
    GET_PRODUCT_DETAILS_ERROR,
    CHECK_IS_OUTSIDE_TERRITORY_SUCCESS,
    SAVE_RECEIVE_SETS_DETAILS,
    checkIsOutsideTerritory,
    showErrorMessagePopup,
    showSuccessMessagePopup,
    showInvalidBarcodePoup,
    invalidBarCodeDetails,
    dChainBarCodeDetails,
    showDChainStatusPopup,
    createReceiveSetsFailure,
    RESET_BULK_BARCODE_DETAILS_DATA,
    SHOW_INVALID_BARCODE_DETAILS,
    SHOW_DCHAIN_BARCODE_DETAILS,
    BULK_BARCODE_DETAILS_DATA,
    SAVE_VALID_BARCODE_COUNT,
} from '../actions';
import { put, delay, select, call } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import createReceiveSets from './createReceiveSetsSaga';
import { rearrangeItems } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

const getData = (payload) => {
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/inventory/transfersets/barcode?accountNumber=${
        encodeURIComponent(payload.accountId.accountId)
    }&barcode=${encodeURIComponent(payload.barcode)}&territory=${encodeURIComponent(payload.territoryId)}`;
    return axios
        .get(url)
        .then((result) => result?.data ?? [])
        .catch((error) => {
            logUiErrorToBackend(error, {
                apiEndPoint: url,
                requestPayload: payload,
            });
            return 'error';
        });
};

const getOutsideTerritoryData = (data) => {
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/inventory/transfersets/isOutsideTerritory?batchNumber=${
        encodeURIComponent(data.batchNumber)
    }&setNumber=${encodeURIComponent(data.setNumber)}`;
    return axios
        .get(url)
        .then((result) => result?.data ?? {})
        .catch((error) => {
            logUiErrorToBackend(error, {
                apiEndPoint: url,
                requestPayload: data,
            });
            return 'error';
        });
};

export function* getSetAndBatchReceiveSets(action) {
    const {
        barcode,
        isManual,
        isBulkAdd,
        territoryId,
        accountId,
        isBarCode,
        isExternalBarcode,
        isFromBarcode,
        isFromScanner,
    } = action.payload;
    const result = yield getData(action.payload);

    const getUniqueListBy = [
        ...new Map(
            result.map((item) => [item['barCodeNumber'], item])
        ).values(),
    ];

    const individualResult = result.reduce((a, b) => Object.assign(a, b), {});
    // const individualResult =  Array.isArray(result) ? result.reduce((a, b) => Object.assign(a, b), {}) : result;

    const receiveSetsListData = yield select(
        (state) => state.receiveSetsListDataReducer.receiveSetsListData
    );

    if (isBulkAdd) {
        try {
            const uniqueBarcode = getUniqueListBy.filter(
                (item) =>
                    !receiveSetsListData.some(
                        (barcodeItem) =>
                            barcodeItem.barcode === item.barCodeNumber
                    )
            );
            yield put({
                type: GET_BARCODE_RECEIVE_SETS_SUCCESS,
                payload: uniqueBarcode,
            });
            // yield put({
            //     type: RESET_BULK_BARCODE_DETAILS_DATA,
            //     payload: receiveSetsListData ? [...receiveSetsListData] : [],
            // });
            yield put({
                type: SHOW_INVALID_BARCODE_DETAILS,
                payload: [],
            });
            yield put({
                type: SHOW_DCHAIN_BARCODE_DETAILS,
                payload: [],
            });
            const invalidBarcodeDetailsData = yield select(
                (state) =>
                    state.receiveSetsListDataReducer.invalidBarcodeDetails
            );
            const dChainBarCodeDetailsData = yield select(
                (state) => state.receiveSetsListDataReducer.dchainBarcodes
            );

            for (const item of getUniqueListBy) {
                // yield delay(2000);
                if (item.statusCode === '11613') {
                    const response = yield call(invalidBarCodeDetails, {
                        ...item,
                        isInvalid: true,
                    });
                    invalidBarcodeDetailsData.push(response.payload);
                    let newArray = [...invalidBarcodeDetailsData];
                    yield put(invalidBarCodeDetails(newArray));
                } else if (item.statusCode === '11911') {
                    const response = yield call(dChainBarCodeDetails, {
                        ...item,
                    });
                    dChainBarCodeDetailsData.push(response.payload);
                    let newArray = [...dChainBarCodeDetailsData];
                    yield put(dChainBarCodeDetails(newArray));
                } else {
                    const dataNew = {
                        setNumber: item.setNumber,
                        batchNumber: item.batchNumber,
                        description: item.description,
                        accountCode: item.accountCode,
                        accountName: item.accountName,
                        barCodeNumber: item.barCodeNumber,
                        isManual: true,
                        isBarCode: isBarCode ? true : false,
                        territoryId: territoryId,
                        accountId: accountId,
                        statusCode: item.statusCode,
                        isBulkAdd: isBulkAdd,
                    };
                    if (isManual) {
                        yield put(checkIsOutsideTerritory(dataNew));
                    }
                    localStorage.setItem('barcodeScan', JSON.stringify(result));
                    localStorage.setItem('barcodeScanSuccess', true);
                }
            }
        } catch (e) {
            const url = `/occ/v2/${localStorage.getItem(
                'baseSiteId'
            )}/inventory/transfersets/barcode?accountNumber=${
                encodeURIComponent(action.payload.accountId.accountId)
            }&barcode=${encodeURIComponent(action.payload.barcode)}&territory=${encodeURIComponent(action.payload.territoryId)}`;
            logUiErrorToBackend(e, {
                apiEndPoint: url,
                requestPayload: action.payload
            });
            localStorage.setItem('barcodeScanSuccess', false);
            localStorage.setItem('barcodeScanError', JSON.stringify(e));
            yield put({ type: GET_BARCODE_RECEIVE_SETS_FAILURE, payload: e });
        }
    } else if (!isBulkAdd) {
        try {
            yield put({
                type: GET_BARCODE_RECEIVE_SETS_SUCCESS,
                payload: individualResult,
            });
            if (individualResult.statusCode === '11613' && isManual) {
                yield put(
                    showInvalidBarcodePoup({
                        isInvalid: true,
                        barcode: barcode,
                    })
                );
            } else if (individualResult.statusCode === '11911') {
                yield put(
                    createReceiveSetsFailure({
                        data: {
                            statusCode: individualResult.statusCode,
                            isManual: isManual,
                            setNo: individualResult?.setNumber,
                            statusDescription: individualResult?.statusMessage,
                            isFromScanner: isFromScanner,
                        },
                    })
                );
            } else {
                const data = {
                    setNumber: individualResult?.setNumber,
                    batchNumber: individualResult?.batchNumber,
                    description: individualResult?.description,
                    isManual: true,
                    isBulkAdd: isBulkAdd,
                    territoryId: territoryId,
                    accountId: accountId,
                    accountCode: individualResult?.accountCode,
                    accountName: individualResult?.accountName,
                    isBarCode: isBarCode ? true : false,
                    barcode: barcode,
                    isFromBarcode: isFromBarcode ? true : false,
                    isExternalBarcode: isExternalBarcode ? true : false,
                    statusCode: individualResult?.statusCode,
                };
                if (isManual) {
                    yield put(checkIsOutsideTerritory(data));
                }
                localStorage.setItem(
                    'barcodeScan',
                    JSON.stringify(individualResult)
                );
                localStorage.setItem('barcodeScanSuccess', true);
            }
        } catch (e) {
            const url = `/occ/v2/${localStorage.getItem(
                'baseSiteId'
            )}/inventory/transfersets/barcode?accountNumber=${
                encodeURIComponent(action.payload.accountId.accountId)
            }&barcode=${encodeURIComponent(action.payload.barcode)}&territory=${encodeURIComponent(action.payload.territoryId)}`;
            logUiErrorToBackend(e, {
                apiEndPoint: url,
                requestPayload: action.payload
            });
            localStorage.setItem('barcodeScanSuccess', false);
            localStorage.setItem('barcodeScanError', JSON.stringify(e));
            yield put({ type: GET_BARCODE_RECEIVE_SETS_FAILURE, payload: e });
        }
    }
}

export function* checkIsOutsideTerritorySaga(action) {
    try {
        const {
            setNumber,
            batchNumber,
            territoryId,
            accountId,
            description,
            statusCode,
            barcode,
            barCodeNumber,
            isBarCode,
            isManual,
            isSetAndBatch,
            isExternalBarcode,
            accountCode,
            accountName,
            isBulkAdd,
        } = action.payload;

        const { receiveSetsListData } = yield select((state) => ({
            receiveSetsListData:
                state.receiveSetsListDataReducer.receiveSetsListData,
            showErrorPopupMessage:
                state.receiveSetsListDataReducer.showErrorPopupMessage,
        }));

        const bulkBarcodeDetails = yield select(
            (state) => state.receiveSetsListDataReducer.bulkBarcodeDetails
        );

        const bulkExcludedData = yield select(
            (state) => state.receiveSetsListDataReducer.bulkExcludedData
        );
        const barcodeDetails = yield select(
            (state) => state.receiveSetsListDataReducer.barcodeDetails
        );

        const isFound = receiveSetsListData?.some((element) => {
            if (element.batchNo == batchNumber && element.setNo === setNumber) {
                return true;
            }
        });
        let result;
        if (!isFound && !isExternalBarcode) {
            result = yield getOutsideTerritoryData(action.payload);
        }
        if (!isFound && !isExternalBarcode) {
            yield put({
                type: CHECK_IS_OUTSIDE_TERRITORY_SUCCESS,
                payload: result,
            });
        }
        const data = {
            setNo: setNumber,
            batchNo: batchNumber,
            territoryId: territoryId,
            accountId: accountId,
            accountCode: result?.accountCode ? result.accountCode : accountCode,
            accountName: result?.accountName ? result.accountName : accountName,
            isBarCode: isBarCode ? true : false,
            description: description,
            isSetOutsideTerritory: result?.isSetOutsideTerritory,
            barcode: result?.barcode ? result.barcode : barcode,
            statusCode: statusCode,
            isSetAndBatch: result?.barcode ? true : false,
        };
        let newArray = [];

        if (isFound === true) {
            yield put(showErrorMessagePopup(true));
            yield put(showSuccessMessagePopup(false));
            newArray = [...receiveSetsListData];
        }
        yield delay(2000);
        yield put(showErrorMessagePopup(false));
        const setsPayload = [
            {
                batchNo: batchNumber,
                isBarCode: isBarCode ? true : false,
                setNo: setNumber,
            },
        ];
        const validationPayload = {
            payload: {
                accountId: accountId?.accountId,
                accountName: accountId?.accountName,
                sets: setsPayload,
                barcode: barCodeNumber,
                territoryId: territoryId,
                isSubmit: false,
                dataList: newArray,
                isManual: isManual ? true : false,
                isSetAndBatch: isSetAndBatch ? true : false,
                isFoundDuplicate: isFound,
                isBulkAdd: isBulkAdd,
            },
        };

        if (!isFound) {
            const res = yield createReceiveSets(validationPayload);

            if (isBulkAdd) {
                bulkBarcodeDetails?.push(data);
                newArray = [...bulkBarcodeDetails, ...receiveSetsListData];
                const getUniqueBarcode = [
                    ...new Map(
                        newArray.map((item) => [
                            item['barcode' || 'barCodeNumber'],
                            item,
                        ])
                    ).values(),
                ];

                const filtered = getUniqueBarcode.filter((i) =>
                    bulkExcludedData?.every(
                        (j) => i['barcode'] !== j['barcode']
                    )
                );

                newArray = [...rearrangeItems(filtered, barcodeDetails)];
                yield put({
                    type: SAVE_RECEIVE_SETS_DETAILS,
                    payload: newArray,
                });
            } else if (!isBulkAdd) {
                if (
                    JSON.parse(
                        localStorage.getItem('createReceiveSetError')
                    ) === '11911' ||
                    JSON.parse(
                        localStorage.getItem('createReceiveSetError')
                    ) === '10830' ||
                    JSON.parse(
                        localStorage.getItem('createReceiveSetError')
                    ) === '10734' ||
                    JSON.parse(
                        localStorage.getItem('createReceiveSetError')
                    ) === '11618'
                ) {
                    newArray = [...receiveSetsListData];
                    yield put({
                        type: SAVE_RECEIVE_SETS_DETAILS,
                        payload: newArray,
                    });
                } else {
                    receiveSetsListData.push(data);
                    newArray = [...receiveSetsListData];
                    yield put({
                        type: SAVE_RECEIVE_SETS_DETAILS,
                        payload: newArray,
                    });
                }
            }

            // if (
            //     JSON.parse(localStorage.getItem('createReceiveSetError')) ===
            //         '11911' ||
            //     JSON.parse(localStorage.getItem('createReceiveSetError')) ===
            //         '10830' ||
            //     JSON.parse(localStorage.getItem('createReceiveSetError')) ===
            //         '10734' ||
            //     JSON.parse(localStorage.getItem('createReceiveSetError')) ===
            //         '11618'
            // ) {
            //     if (isBulkAdd) {

            //         bulkBarcodeDetails.push(data);
            //         newArray = [...bulkBarcodeDetails];
            //         const getUniqueBarcode = [
            //             ...new Map(
            //                 newArray.map((item) => [item['barcode'], item])
            //             ).values(),
            //         ];
            //         console.log('getUniqueBarcode', getUniqueBarcode);

            //         newArray = [...getUniqueBarcode];
            //         console.log('newArray', newArray);
            //         yield put({
            //             type: SAVE_RECEIVE_SETS_DETAILS,
            //             payload: newArray,
            //         });
            //     }
            //     newArray = [...receiveSetsListData];
            //     console.log('newArray', newArray);
            //     yield put({
            //         type: SAVE_RECEIVE_SETS_DETAILS,
            //         payload: newArray,
            //     });
            // } else {
            //     // if (isBulkAdd) {
            //     //     bulkBarcodeDetails.push(data);
            //     //     newArray = [...bulkBarcodeDetails];
            //     //     const getUniqueBarcode = [
            //     //         ...new Map(
            //     //             newArray.map((item) => [item['barcode'], item])
            //     //         ).values(),
            //     //     ];
            //     //     console.log('getUniqueBarcode', getUniqueBarcode);

            //     //     newArray = [...getUniqueBarcode];
            //     //     console.log('newArray', newArray);
            //     //     yield put({
            //     //         type: SAVE_RECEIVE_SETS_DETAILS,
            //     //         payload: newArray,
            //     //     });
            //     // } else {
            //     receiveSetsListData.push(data);
            //     newArray = [...receiveSetsListData];
            //     console.log('newArray', newArray);
            //     yield put({
            //         type: SAVE_RECEIVE_SETS_DETAILS,
            //         payload: newArray,
            //     });
            // }
            // }
        }
    } catch (e) {
        const url = `/occ/v2/${localStorage.getItem(
            'baseSiteId'
        )}/inventory/transfersets/isOutsideTerritory?batchNumber=${
            encodeURIComponent(action.payload.batchNumber)
        }&setNumber=${encodeURIComponent(action.payload.setNumber)}`;
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload,
        });
    }
}

export function* getProductDetails(action) {
    const { productCFN, salesOrg } = action.payload;
    let url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/productDetails/${encodeURIComponent(productCFN)}?salesOrg=${encodeURIComponent(salesOrg)}`;
    try {
        const result = yield axios.get(url).then((response) => response.data);
        yield put({
            type: GET_PRODUCT_DETAILS_SUCCESS,
            payload: result.productDetails,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_PRODUCT_DETAILS_ERROR,
            payload: errorHandler('503'),
        });
    }
}
